import React, { useState, useCallback, useEffect } from "react";
import { useSelector } from "react-redux";
import useStyles from "./style";
import { Button, Grid, Typography ,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle} from "@mui/material";
import {Delete} from "@mui/icons-material";
import { DataGrid  } from "@mui/x-data-grid";
import * as XLSX from "xlsx";
import Papa from "papaparse";
import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from 'moment-timezone';
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";
import _ from "lodash";
import { styled } from "@mui/system";

//Services
import notificationApi from "Services/Notifications";

//component 
import BulkSMSSelector from "./bulksmsmodel";

const StyledButton = styled(Button)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  backgroundColor: theme.palette.error.main,
  "&:hover": {
    backgroundColor: theme.palette.error.dark
  },
  "&.Mui-disabled": {
    backgroundColor: theme.palette.action.disabledBackground
  }
}));

const Passenger = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const timezone = useSelector((state) => state.timezone.timezone);

  const [row, setRow] = useState([]);
  const [notifyrow, setnotifyRow] = useState([]);
  const [bulkrow, setbulkrow] = useState([]);  
  const [selectedRows, setSelectedRows] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  //Pagination

  const [page, setPage] = useState(1); // Initial page number
  const [pageSize, setPageSize] = useState(5); // Initial page size
  const [totalPages, setTotalPages] = useState(1);

  // Get Passenger list api
  const getPassengers = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setTotalPages(res?.data?.data?.totalRecords || 1);
        setRow(res?.data?.data?.data);
      } else {
        setRow([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("error fetch service area", err);
    };
    notificationApi
      .getUsersList({ page, limit: "unlimited" })
      .then(onSuccess, onFailure);
  }, []);

  const getnotifications = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setTotalPages(res?.data?.data?.totalRecords || 1);
        setnotifyRow(res?.data?.data?.data);
      } else {
        setnotifyRow([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("error fetch service area", err);
    };
    notificationApi
      .getNotificationsList({ page, limit: pageSize ,notification_type:"SMS" })
      .then(onSuccess, onFailure);
  }, [page, pageSize]);

  const getallnotifications = useCallback(() => {
  //  dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
   //   dispatch(hideLoader());
      if (res?.data?.status === true) {
        setbulkrow(res?.data?.data?.data);
      } else {
        setbulkrow([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("error fetch service area", err);
    };
    notificationApi
      .getNotificationsList({ page:1, limit: "unlimited" ,notification_type:"SMS" })
      .then(onSuccess, onFailure);
  }, []);  

  useEffect(() => {
    getPassengers();
    getnotifications();
    getallnotifications();
  }, [getPassengers , getnotifications]);

  const handleDownloadAll = () => {
     const csv = Papa.unparse(bulkformatteddatas);
     const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
     const url = URL.createObjectURL(blob);
     const link = document.createElement("a");
     link.href = url;
     link.setAttribute("download", "All Smsnotifications.csv");
     document.body.appendChild(link);
     link.click();
     document.body.removeChild(link);
   };  

  const handlePageChange = (newPage) => {
    let theNewPage = parseInt(newPage) + 1;
    if (theNewPage >= 1) {
      setPage(theNewPage);
    }
  };

  const handleCopy = () => {
      // Define column widths
      const columnWidths = [5, 15, 25, 15, 15, 15]; // Adjust widths as needed
  
      // Helper function to pad text to the desired width
      const padText = (text, width) => {
        return (text ?? "").toString().padEnd(width, " ");
      };
      // Create table header
      const header = [
        padText("S.NO", columnWidths[0]),
        padText("Message", columnWidths[1]),
        padText("Passengers", columnWidths[2]),
        padText("Created At", columnWidths[3]),
      ].join("");
    
      // Create table rows
      const rows = dataRows
        .map((row) =>
          [
            padText(row.sno, columnWidths[0]),
            padText(row.message, columnWidths[1]),
            padText(row.passengers, columnWidths[2]),
            padText(row.createdat, columnWidths[3]),
          ].join("")
        )
        .join("\n");
    
      // Combine header and rows
      const formattedContent = [header, rows].join("\n");
    
      // Copy to clipboard
      navigator.clipboard.writeText(formattedContent).then(() => {
        alert("Table copied to clipboard!");
      });
  };

  const handleDownloadExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(formatteddatas);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Services");
    XLSX.writeFile(workbook, "Smsnotifications.xlsx");
  };

  const handleDownloadCSV = () => {
    const csv = Papa.unparse(formatteddatas);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Smsnotifications.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadPDF = () => {
    const doc = new jsPDF();
    const tableData = dataRows.map((row) => [
      row.sno,
      row.message,
      row.passengers,
      row.createdat,
    ]);
    doc.autoTable({
      head: [["S.NO","Message","Passengers","Created At"]],
      body: tableData,
    });
    doc.save("Smsnotifications.pdf");
  };

  function formatDate(inputDate) {

    if (!inputDate) {
      return "--"; // Return '--' if inputDate is null or undefined
    }
    return moment(inputDate).tz(timezone).format("YYYY-MM-DD hh:mm A");
  }

  const calculateSno = (pageIndex, pageSize, index) => {
    return (pageIndex - 1) * pageSize + index + 1;
  };

  const dataRows = _.map(row || [], (data, index) => ({
    mobile: data?.countryCode+" "+ ( data?.mobileNumber.startsWith("0") ? data.mobileNumber.substring(1) : data.mobileNumber ),
    row: data,
  }));

  const notifydataRows = _.map(notifyrow || [], (data, index) => ({
    id: data?._id,
    sno: calculateSno(page, pageSize, index),
    message: data?.message,
    passengers: Array.isArray(data?.sent_to_names) ? data.sent_to_names.join(', ') : '',
    createdat: formatDate(data?.created_at),    
    row: data,
  }));

  const formatteddatas = notifydataRows.map((row) => ({
    "S.NO": row.sno,
    "Message":row.message,
    "Passengers":row.passengers,
    "Created AT": row.createdat,
  }));

  const bulkdataRows = _.map(
    _.orderBy(bulkrow || [], ['createdAt'], ['asc']),
    (data, index) => ({
    id: data?._id,
    sno: calculateSno(page, pageSize, index),
    message: data?.message,
    passengers: Array.isArray(data?.sent_to_names) ? data.sent_to_names.join(', ') : '',
    createdat: formatDate(data?.created_at),    
    row: data,
  }));  
  
  const bulkformatteddatas = bulkdataRows.map((row) => ({
   "S.NO": row.sno,
    "Message":row.message,
    "Passengers":row.passengers,
    "Created AT": row.createdat,
  }));    
  
  const columns = [
    {
      field: "sno",
      headerName: "S.No",
      flex:0.5,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <>
            <div className={classes.lightText}>
              <Typography variant="body2">{params?.row?.sno}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "message",
      headerName: "Message",
      flex:0.6,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.message}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "passengers",
      headerName: "Passengers",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.passengers}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "createdat",
      headerName: "Created At",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.createdat}</Typography>
            </div>
          </>
        );
      },
    },
  ];
  
  const handleSendMessage = ( selecteddatas , message) => {
   // console.log("Datas", selecteddatas);
   // console.log("Message:", message);
 
    dispatch(showLoader("Loading please wait..."));

    let validatationPass = true;

    const data = {
      selecteddatas: selecteddatas,
      message: message,
    };
    
   // console.log('data--->',data);
    
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message: res?.data?.message || "SMS sent Successfully",
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );
        getnotifications(); 
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Error while sending SMS",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("update profile details api", err);
    };

    if (validatationPass) {
      notificationApi.sendsmsnotifications({ ...data }).then(onSuccess, onFailure);
    }

  };

  const handleSelectionChange = (newSelection) => {
    setSelectedRows(newSelection);
  };

  const handleDeleteClick = () => {
    if (selectedRows.length === 0) {
      dispatch(
        showSnackbar({
          message: "No rows selected",
          autoHideDuration: 1000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "warning",
        })
      );
      return;
    }else{
    setOpenDialog(true);
    }
  };

  const handleDeleteConfirm = () => {
    setOpenDialog(false);
    const idsToDelete = selectedRows; // These are _id values from getRowId
  
     dispatch(showLoader("Deleting..."));

    const onSuccess = (res) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: "Deleted successfully!",
          variant: "success",
          anchorOrigin: { vertical: "top", horizontal: "right" },
        })
      );
      getnotifications(); // Refresh data
    };
  
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Delete failed",
          variant: "error",
          anchorOrigin: { vertical: "top", horizontal: "right" },
        })
      );
    };
  
    notificationApi.deleteMultipleNotifications({ ids: idsToDelete })
      .then(onSuccess, onFailure);

  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  return (
    <>

<Grid container className={classes.bulknotifyblock}>
<BulkSMSSelector passengers={dataRows} onSendMessage={handleSendMessage} />
</Grid>

<Grid container className={classes.root}>

<Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
<Button variant="contained" onClick={handleCopy}>
  COPY
</Button>
</Grid>
<Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
<Button variant="contained" onClick={handleDownloadExcel}>
  EXCEL
</Button>
</Grid>
<Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
<Button variant="contained" onClick={handleDownloadCSV}>
  CSV
</Button>
</Grid>
<Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
<Button variant="contained" onClick={handleDownloadPDF}>
  PDF
</Button>
</Grid> <Grid item xs={2} md={2} lg={2} xl={2} className={classes.funBtn}>
                      <Button variant="contained" onClick={handleDownloadAll}>
                      Download ALL
                      </Button>
                      </Grid>  

<Grid item xs={6} md={6} lg={6} xl={6} className={classes.funBtn}>
<StyledButton
          variant="contained"
          startIcon={<Delete />}
          disabled={selectedRows.length === 0}
          onClick={handleDeleteClick}
        >
          Delete Selected ({selectedRows.length})
        </StyledButton>
</Grid>


<Grid item xs={12}>
<section className={classes.dataGridTable}>
  <DataGrid
    rows={notifydataRows}
    columns={columns}
    pageSize={pageSize}
    onPageSizeChange={(newPageSize) => {
      setPageSize(newPageSize);
      setPage(1);
    }}
    onPageChange={(newPage) => handlePageChange(newPage)}
    rowsPerPageOptions={[5, 10, 25, 50]}
    pagination
    autoHeight={true}
    checkboxSelection
    disableSelectionOnClick
    onSelectionModelChange={handleSelectionChange}
    selectionModel={selectedRows}
    scrollbarSize={4}
    rowHeight={70}
    style={{ padding: "10px", borderRadius: "0px" }}
    paginationMode="server"
    rowCount={totalPages}
  />
<Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
      >
        <DialogTitle id="delete-dialog-title">
          Confirm Deletion
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="delete-dialog-description">
            Are you sure you want to delete {selectedRows.length} selected {selectedRows.length === 1 ? "row" : "rows"}? This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            Cancel
          </Button>
          <Button onClick={handleDeleteConfirm} color="error" variant="contained"  sx={{ color:"#fff" }} autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>

</section>
</Grid>
</Grid>

    </>
  );
};

export default Passenger;
